import React from 'react';
import { toast } from 'react-toastify';

export const UploadEDocContainer = ({ onFileClick, childAddable }: any) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState<any>();
  const [title, setTitle] = React.useState('');

  const handleOpen = (type: string) => {
    if (childAddable?.IsChildAddable) {
      setTitle(type);
      setDialogOpen(true);
    } else {
        toast.info('It is not addable');
    }
  };
  const onFormChange: any = (event: any, field: string) => {
    setSelectedValue({ ...selectedValue, [field]: event });
  }

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleFolderSubmit = (event: any) => {
    event.preventDefault();
    onFileClick('folder', setSelectedValue);
    setSelectedValue({});
    handleClose();
  };

  const handleSubmit = (event: any) => {
    const file = event.target.files[0];
    onFileClick(title.toLowerCase(), file);
    handleClose();
  };

  return (
    <>
      <div className="space-x-2">
        <button
          onClick={() => handleOpen('Folder')}
          className="m-2 bg-blue-500 text-white rounded font-semibold px-4 py-2 hover:bg-blue-600 transition"
        >
          Add Folder
        </button>
        <button
          onClick={() => handleOpen('File')}
          className="m-2 bg-blue-500 text-white rounded font-semibold px-4 py-2 hover:bg-blue-600 transition"
        >
          Add File
        </button>
        <button
          onClick={() => handleOpen('Image')}
          className="m-2 bg-blue-500 text-white rounded font-semibold px-4 py-2 hover:bg-blue-600 transition"
        >
          Add Image
        </button>
        <button
          onClick={() => handleOpen('Video')}
          className="m-2 bg-blue-500 text-white rounded font-semibold px-4 py-2 hover:bg-blue-600 transition"
        >
          Add Video
        </button>
      </div>
      {dialogOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="fixed inset-0 bg-black opacity-50"></div>
          <div className="bg-white rounded-lg p-6 z-10 w-full max-w-lg mx-auto">
            <h2 className="text-xl font-semibold mb-4">Add {title}</h2>
            <div>
            {title === 'Image' && (
            <input
                accept="image/*"
                id="contained-button-file"
                multiple
                onChange={(event) => handleSubmit(event)}
                type="file"
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
            />
        )}
        {title === 'Video' && (
            <input
                accept="video/*"
                id="contained-button-file"
                multiple
                onChange={(event) => handleSubmit(event)}
                type="file"
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
            />
        )}
        {title === 'File' && (
            <input
                accept="*/*"
                id="contained-button-file"
                multiple
                onChange={(event) => handleSubmit(event)}
                type="file"
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
            />
        )}
        {title === 'Folder' && (
            <input
                id="NewFolderName"
                name="NewFolderName"
                onChange={(event) => onFormChange(event,'NewFolderName')}
                placeholder="New Folder Name"
                required
                type="text"
                value={selectedValue?.NewFolderName}
                className="block w-full p-2 mt-2 border border-gray-300 rounded shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
            />
        )}
            </div>
            <div className="mt-4 flex justify-end space-x-2">
              <button
                onClick={handleClose}
                className="bg-gray-500 text-white rounded px-4 py-2 hover:bg-gray-600 transition"
              >
                CLOSE
              </button>
              {title !== 'Folder' && (
                <button
                  onClick={handleSubmit}
                  className="bg-blue-500 text-white rounded px-4 py-2 hover:bg-blue-600 transition"
                >
                  SAVE
                </button>
              )}
              {title === 'Folder' && (
                <button
                  onClick={handleFolderSubmit}
                  className="bg-blue-500 text-white rounded px-4 py-2 hover:bg-blue-600 transition"
                >
                  SAVE
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};